export default "__VITE_ASSET__CmSf4ZeV__"